import { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useWorkflowById } from "../../../../../../reactQuery/workflows";
import useBoardIdByKey from "../../../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../../../reactQuery/response";

export function useStatusDropdown(workflowId) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [workflow, setWorkflow] = useState(
    searchParams.get("workflow_Step") || ""
  );
  const { id } = useBoardIdByKey();
  const { data: workflowStepsQuery } = useWorkflowById(workflowId, id);

  useEffect(() => {
    setWorkflow(searchParams.get("workflow_Step") || "");
  }, [searchParams]);

  const workflowSteps = useMemo(
    () =>
      [...getResponseData(workflowStepsQuery, [])].sort(
        (stepA, stepB) => stepA.step_sequence - stepB.step_sequence
      ),
    [workflowStepsQuery]
  );

  const handleChange = useCallback(
    (event) => {
      const workflowStepId = event.target.value;
      const nextSearchParams = new URLSearchParams(searchParams);

      setWorkflow(workflowStepId);

      if (!workflowStepId) {
        nextSearchParams.delete("workflow_Step");
      } else {
        nextSearchParams.set("workflow_Step", workflowStepId);
      }

      setSearchParams(nextSearchParams);
    },
    [searchParams, setSearchParams]
  );

  return {
    handleChange,
    workflow,
    workflowSteps,
  };
}
